module.exports = __webpack_public_path__ + "static/media/input-button.117dd4c0.svg";